import { useEffect, useState } from 'react';
export const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);
    const MAX_MOBILE_WIDTH = 768;
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= MAX_MOBILE_WIDTH);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    return [isMobile];
};
